const lightBlue = require('@material-ui/core/colors/lightBlue');
const yellow = require('@material-ui/core/colors/yellow');

// Colors
const infoColor = lightBlue.default[500];
const warningColor = yellow.default[500];

// Spacing
const drawerWidth = 200;
const notificationCenterWidth = 300;
const MobileBreakpoint = 960;

export {
  infoColor,
  warningColor,
  drawerWidth,
  notificationCenterWidth,
  MobileBreakpoint
};
